import { connect } from 'react-redux'
import { removeFilter, setFilterText, clearFilter } from '../actions/filter'
import { fetchPosts } from '../actions/posts'
import { pushStateChange } from '../history'
import ActiveFilterList from '../components/active-filter-list'

const mapStateToProps = (state) => {
	return {
		filter: state.filter
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onFilterClick: (filterName, filterValue) => {
			dispatch(removeFilter(filterName, filterValue))
			dispatch(fetchPosts())
			dispatch(function(dispatch, getState){
				return pushStateChange(dispatch, getState);
			})
		},
		onTextFilterClick: () => {
			dispatch(setFilterText(''))
			dispatch(fetchPosts())
			dispatch(function(dispatch, getState){
				return pushStateChange(dispatch, getState);
			})
		},
		onClearFiltersClick: () => {
			dispatch(clearFilter())
			dispatch(fetchPosts())
			dispatch(function(dispatch, getState){
				return pushStateChange(dispatch, getState);
			})
		}
	}
}

const ActiveFilterListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ActiveFilterList)

export default ActiveFilterListContainer
